import type { AxiosInstance } from 'axios';

import { invertMap } from '@/sections/insights/queryBuilder/entities/common/invert';
import {
  getNotFromSimpleFilter,
  getOperatorFromQueryFilter,
  getOperatorFromSimpleFilter,
  getValueFromQueryFilter,
  getValueFromSimpleFilter,
} from '@/sections/insights/queryBuilder/entities/common/translators';
import type {
  SimpleFilter,
  SimpleFilterDefinition,
} from '@/sections/insights/queryBuilder/entities/types';
import type { QueryFilter } from '@/types';

const valueMap: Record<string, string> = {
  true: 'Yes',
  false: 'No',
};

const valueMapInverse = invertMap(valueMap);

/**
 * Risk KEV filter - queries the kev boolean on the related Vulnerability node
 * via INSTANCE_OF relationship (Risk -> INSTANCE_OF -> Vulnerability)
 */
export const RiskKEV: SimpleFilterDefinition = {
  apiField: 'kev',
  uiField: 'KEV',
  inputType: 'dropdown',
  getAvailableValues: (_axios: AxiosInstance) => Promise.resolve(['Yes', 'No']),
  operators: ['is', 'is not'],

  translateForUI: (queryFilter: QueryFilter): SimpleFilter => {
    return {
      field: 'KEV',
      operator: getOperatorFromQueryFilter(queryFilter),
      value: getValueFromQueryFilter(valueMap, queryFilter),
    };
  },

  matchesQueryFilter: (queryFilter: QueryFilter): boolean => {
    return (
      queryFilter.field === 'kev' &&
      queryFilter.relationshipNodeLabel === 'Vulnerability' &&
      queryFilter.relationshipDirection === 'target' &&
      queryFilter.relationshipLabel === 'INSTANCE_OF'
    );
  },

  translateForAPI: (simpleFilter: SimpleFilter): QueryFilter => {
    const stringValue = getValueFromSimpleFilter(valueMapInverse, simpleFilter);
    const boolValue = stringValue === 'true';

    return {
      field: 'kev',
      operator: getOperatorFromSimpleFilter(simpleFilter),
      value: boolValue,
      not: getNotFromSimpleFilter(simpleFilter),
      relationshipNodeLabel: 'Vulnerability',
      relationshipDirection: 'target',
      relationshipLabel: 'INSTANCE_OF',
    };
  },
};
